import { InitialRegisterForm } from '../register.interface'

export const getRegisterInitialValues = (form?: Partial<InitialRegisterForm>) => {
  if (form) {
    return {
      fio: form.fio ?? null,
      email: form.email ?? null,
      password: form.password ?? null,
      passwordConfirm: form.passwordConfirm ?? null,
      companyName: form.companyName ?? form.name ?? null,
      companyInn: form.companyInn ?? null,
      companyOgrn: form.companyOgrn ?? null,
    }
  }

  return {
    fio: null,
    email: null,
    password: null,
    passwordConfirm: null,
    companyName: null,
    companyInn: null,
    companyOgrn: null,
  }
}
